import { useState } from 'react'
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown'
import '@leenguyen/react-flip-clock-countdown/dist/index.css'
import TicketForm from './TicketForm'
import ComingSoon from './ComingSoon'
import { isAdmin, isEnabled, isLocalHost, isStaging } from '../utils/common'

const COUNTDOWN_TARGET = new Date('2026-09-01T00:00:00+02:00')
const bypassCountdown = isAdmin || isLocalHost || isStaging

const PERKS = [
	'Säker betalning via Stripe',
	'Biljetten kommer direkt via e-post och SMS',
	'Tidigare inträde från 09.30',
	'Smidigare inpassering med QR-kod',
]

const TicketsCart = () => {
	const [countdownComplete, setCountdownComplete] = useState(new Date() >= COUNTDOWN_TARGET)

	const showForm = isEnabled && (bypassCountdown || countdownComplete)
	const showCountdown = isEnabled && !bypassCountdown && !countdownComplete
	const showComingSoon = !isEnabled

	return (
		<section className='hx-tickets hx-bleed'>
			<div className='hx-wrap'>
				<div className='hx-lede'>
					<h2>Köp din biljett till mässan</h2>
					<p>
						Upplev hundratals utställare, föredrag, workshops och behandlingar, en helg fylld av
						inspiration, kunskap och nya möten.
					</p>
				</div>

				{showForm && <TicketForm />}

				{showCountdown && (
					<div className='hx-gate'>
						<FlipClockCountdown
							to={COUNTDOWN_TARGET}
							onComplete={() => setCountdownComplete(true)}
							showLabels={false}
							renderMap={[false, true, true, true]}
						/>
					</div>
				)}

				{showComingSoon && (
					<div className='hx-gate'>
						<ComingSoon />
					</div>
				)}

				<ul className='hx-perks'>
					{PERKS.map((perk) => (
						<li key={perk}>
							<span className='hx-perks__tick' aria-hidden='true'>
								✓
							</span>
							<span>{perk}</span>
						</li>
					))}
				</ul>

				<p className='hx-fineprint'>
					Förköpsentrén öppnar kl 9.30, övriga kassor kl 10.00. Biljetten skickas till din
					e-postadress/SMS och du visar upp QR-koden i din telefon när du kommer till entrén. Barn
					under 12 år går in gratis i vuxens sällskap.
				</p>
			</div>
		</section>
	)
}

export default TicketsCart
